import React, { Component } from "react";
import Konva from "konva";
import { render } from "react-dom";
import { Image, Circle, Arrow, Line } from "react-konva";

class Arrows extends Component {
    
  render() {
    return (
        <Arrow
        ref={node => {
          this.arrow = node;
        }}
        x={this.props.rect.x}
        y={this.props.rect.y}
        width={this.props.rect.width}
        height={this.props.rect.height}
        fill={this.props.rect.fill}
        name={this.props.rect.name}
        stroke={this.props.rect.stroke}
        strokeWidth={this.props.rect.strokeWidth}
        draggable
        rotation={this.props.rect.rotation}
        scaleX={this.props.rect.scaleX}
        scaleY={this.props.rect.scaleY}
        resizeEnabled
        points={this.props.rect.points}
        pointerLength={this.props.rect.pointerLength}
        pointerWidth={this.props.rect.pointerWidth}
        dash={this.props.rect.dash}
        pointerAtBeginning={this.props.rect.pointerAtBeginning}
      />
    );
  }
}
export default Arrows;


// WEBPACK FOOTER //
// ./src/components/InfluencerMap/CustomerInfluencerMap/CustomerInfluencerMapCanvasRounds/Arrow/Arrow.jsx